module.exports = __webpack_public_path__ + "css/swiperMain.css";